var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFileArrowUp = function SvgFileArrowUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.19 2.69a1.5 1.5 0 0 1 1.06-.44h9a.75.75 0 0 1 .53.22l5.25 5.25c.141.14.22.331.22.53v12a1.5 1.5 0 0 1-1.5 1.5H5.25a1.5 1.5 0 0 1-1.5-1.5V3.75c0-.398.158-.78.44-1.06Zm9.75 1.06H5.25v16.5h13.5V8.56l-4.81-4.81Z",
    fill: "#3D4043"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.25 2.25A.75.75 0 0 1 15 3v4.5h4.5a.75.75 0 0 1 0 1.5h-5.25a.75.75 0 0 1-.75-.75V3a.75.75 0 0 1 .75-.75ZM11.47 10.72a.75.75 0 0 1 1.06 0l2.625 2.625a.75.75 0 1 1-1.06 1.06L12 12.311l-2.095 2.094a.75.75 0 0 1-1.06-1.06l2.625-2.625Z",
    fill: "#3D4043"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 10.5a.75.75 0 0 1 .75.75v6a.75.75 0 0 1-1.5 0v-6a.75.75 0 0 1 .75-.75Z",
    fill: "#3D4043"
  })));
};
export default SvgFileArrowUp;